import { r as registerInstance, h, e as Host } from './index-bfb2bce5.js';

const ttuiCardCss = ":host{border-radius:var(--card-border-radius);box-shadow:0px 4px 8px rgb(45 45 45 / 8%);display:block;margin-bottom:var(--gutter)}";

const Card = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
};
Card.style = ttuiCardCss;

export { Card as C };

//# sourceMappingURL=ttui-card-9d6bec9c.js.map